import React, { useState } from 'react'

function Contact() {

    const [data,setData] = useState({
        fullName: '',
        contact: '',
        email: '',
        message: ''
    });

    const InputEvent = (event) => {
        const {name,value} = event.target;
        setData((preVal)=>{
            return {
                ...preVal,
                [name] : value,
            }
        })
    }

    const fSubmit = (e) => {
        e.preventDefault();
        alert(`Hello ${data.fullName}, Your Contact is ${data.contact}, Your Email is ${data.email}, Your Message is ${data.message}`)
    }

    return (
        <>
        <div className="my-5">
           <h1 className="text-center">Contact Us</h1>
        </div>
        <div className="container contact_div">
            <div  className="row">
                <div className="col-md-6 col-10 mx-auto">
                    <form onSubmit={fSubmit}>
                    <div class="mb-3">
                        <label for="full_name" class="form-label">
                            Full Name
                        </label>
                        <input 
                        type="text" 
                        class="form-control" 
                        id="full_name" 
                        name="fullName"
                        value={data.fullName}
                        onChange={InputEvent}
                        placeholder="Enter Your Name" 
                        required
                        />
                        </div>

                        <div class="mb-3">
                        <label for="p_number" class="form-label">
                            Contact No.
                        </label>
                        <input 
                        type="number" 
                        class="form-control" 
                        id="p_number" 
                        name="contact"
                        value={data.contact}
                        onChange={InputEvent}
                        placeholder="Enter Your Contact No." 
                        maxLength= "10"
                        minLength="10"
                        min='1'
                        required
                        />
                        </div>

                        <div class="mb-3">
                        <label for="email" class="form-label">
                            Email Address
                        </label>
                        <input 
                        type="email" 
                        class="form-control" 
                        id="email" 
                        name="email"
                        value={data.email}
                        onChange={InputEvent}
                        placeholder="Enter Your Email" 
                        required
                        />
                        </div>

                        <div class="mb-3">
                        <label for="Message" class="form-label">
                            Message
                        </label>
                        <textarea 
                        class="form-control" 
                        id="exampleFormControlTextarea1" 
                        rows="3"
                        name="message"
                        value={data.message}
                        onChange={InputEvent}
                        required
                        >
                        </textarea>
                        </div>

                        <div class="col-auto">
                        <button type="submit" class="btn btn-outline-success mb-3">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </>
    )
}

export default Contact
